import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { PatientComponent } from "./component/patient/patient.component";
import { PatientDetailsComponent } from "./component/patient-details/patient-details.component";
import { HomeComponent } from "./authentication/home/home.component";
import { RegisterComponent } from "./authentication/register/register.component";
import { DashboardComponent } from "./component/dashboard/dashboard.component";
import { InfoBasicComponent } from "./authentication/info-basic/info-basic.component";
import { PlansComponent } from "./authentication/plans/plans.component";
import { PrescriptionComponent } from "./component/prescription/prescription.component";
import { ExpandRegisterComponent } from "./component/expand-register/expand-register.component";
import { PageNotFoundComponent } from "./component/page-not-found/page-not-found.component";
import { ProfilesComponent } from "./component/profiles/profiles.component";
import { MessagesComponent } from "./component/messages/messages.component";
import { HelpComponent } from "./component/help/help.component";
import { ContactComponent } from "./component/contact/contact.component";
import { AppointmentsSidebarComponent } from "./component/appointments-sidebar/appointments-sidebar.component";
import { DoctorProfileComponent } from "./component/doctor-profile/doctor-profile.component";
import { PatientProfileComponent } from "./component/patient-profile/patient-profile.component";
import { componentComponent } from "./component/component.component";
import { AuthGuard } from "./authguard/auth.guard";
import { CheckinComponent } from "./component/checkin/checkin.component";
import { NavbarComponent } from "./common-component/navbar/navbar.component";
import { CheckoutComponent } from "./component/checkout/checkout.component";
import { UsrActAckComponent } from "./authentication/usr-act-ack/usr-act-ack.component";
import { PhydashComponent } from "./component/phydash/phydash.component";
import { SetNewPassComponent } from "./authentication/set-new-pass/set-new-pass.component";
import { PatientListComponent } from "./component/patient-list/patient-list.component";
import { FrontDeskComponent } from "./component/front-desk/front-desk.component";
import { EditprescComponent } from "./component/editpresc/editpresc.component";
import { UpdateLabComponent } from "./component/update-lab/update-lab.component";
import { AdmindashboardComponent } from "./component/admindashboard/admindashboard.component";
import { FdeskProfileComponent } from "./component/fdesk-profile/fdesk-profile.component";
import { PatientEditProfileComponent } from "./component/patient-edit-profile/patient-edit-profile.component";
import { PatientDeleteProfileComponent } from "./component/patient-delete-profile/patient-delete-profile.component";
import { DoctorEditProfileComponent } from "./component/doctor-edit-profile/doctor-edit-profile.component";
import { DeleteDoctorProfileComponent } from "./component/delete-doctor-profile/delete-doctor-profile.component";
import { EditFdeskProfileComponent } from "./component/edit-fdesk-profile/edit-fdesk-profile.component";
import { DeleteFdeskProfileComponent } from "./component/delete-fdesk-profile/delete-fdesk-profile.component";
import { SearchUserComponent } from "./component/search-user/search-user.component";
import { RoleGuard } from "./authguard/role-guard";
import { OrganisationEditComponent } from "./component/organisation-edit/organisation-edit.component";
import { OrgsrvComponent } from "./component/orgsrv/orgsrv.component";
import { DoctorCalendarComponent } from "./component/doctor-calendar/doctor-calendar.component";
import { OnlineDoctorAppointmentComponent } from "./component/online-doctor-appointment/online-doctor-appointment.component";
import { AppointmentRequestComponent } from "./component/appointment-request/appointment-request.component";
import { InvoiceComponent } from "./component/invoice/invoice.component";
import { DoctorConsultationComponent } from "./component/doctor-consultation/doctor-consultation.component"
import { VedioHomeComponent } from './component/vedio-components/home/home.component';
import { ViewConsultationAppointmentComponent } from "./component/view-consultation-appointment/view-consultation-appointment.component";
import { ConsultationSummaryComponent } from './component/consultation-summary/consultation-summary.component';
import { FeedbackComponent } from './component/feedback/feedback.component';
import { ViewAppointmentPatientComponent } from "./component/view-appointment-patient/view-appointment-patient.component";
import { AppointmentSearchComponent } from "./component/appointment-search/appointment-search.component";
import { DoctorSearchComponent } from "./component/doctor-search/doctor-search.component";
import { PhysicianTransactionComponent } from "./component/physician-transaction/physician-transaction.component";
import { LoginNewComponent } from "./component/login-new/login-new.component";
import { ForgotPassNewComponent } from "./component/forgot-pass-new/forgot-pass-new.component";
import { ResetPassNewComponent } from "./component/reset-pass-new/reset-pass-new.component";
import { CreateAccountComponent } from "./component/create-account/create-account.component";
import { PatientMembersComponent } from "./component/patient-members/patient-members.component";
import { AppointmentsPastComponent } from "./component/appointments-past/appointments-past.component";
import { AppointmentsPatientComponent } from "./component/appointments-patient/appointments-patient.component";
import { PatientAccountComponent } from "./component/patient-account/patient-account.component";
import { PatientAddComponent } from "./component/patient-add/patient-add.component";
import { SuperadminPhysiciansComponent } from "./component/superadmin-physicians/superadmin-physicians.component";
import { SpecialitiesComponent } from "./component/specialities/specialities.component";
import { DefaultPayoutComponent } from "./component/default-payout/default-payout.component";
import { SuperadminPhyDetailComponent } from './component/superadmin-phy-detail/superadmin-phy-detail.component';
import { SuperadminPatientsComponent } from "./component/superadmin-patients/superadmin-patients.component";
import { SuperadminPatDetailComponent } from "./component/superadmin-pat-detail/superadmin-pat-detail.component";
import { CouponsGenerateComponent } from "./component/coupons-generate/coupons-generate.component";
import { CouponsSearchComponent } from "./component/coupons-search/coupons-search.component";
import { CouponsEditComponent } from "./component/coupons-edit/coupons-edit.component";
import { PatientChatComponent } from "./component/patient-chat/patient-chat.component";
import { SuperadminAppointmentComponent } from "./component/superadmin-appointment/superadmin-appointment.component";
import { MyfilesComponent } from "./component/myfiles/myfiles.component";
import { PhysicianPayloadComponent } from "./component/physician-payload/physician-payload.component"
import { AdhocApptComponent } from "./component/adhoc-appt/adhoc-appt.component";
import { AdhocNewapptComponent } from "./component/adhoc-newappt/adhoc-newappt.component";
import { PatientHelathStatsUpdateComponent } from "./component/patient-helath-stats-update/patient-helath-stats-update.component";
import { PatientrecsearchComponent } from "./component/patientrecsearch/patientrecsearch.component";
import { SuperadminMedicineCreateComponent } from "./component/superadmin-medicine-create/superadmin-medicine-create.component";
import { SuperadminMedicineSearchComponent } from "./component/superadmin-medicine-search/superadmin-medicine-search.component";
import { SuperadminAddcategoryComponent } from "./component/superadmin-addcategory/superadmin-addcategory.component";
import { SuperadminAddsubcategoryComponent } from "./component/superadmin-addsubcategory/superadmin-addsubcategory.component";
import { PrescTempCreateComponent } from "./component/presc-temp-create/presc-temp-create.component";
import { PrescTempEditComponent } from "./component/presc-temp-edit/presc-temp-edit.component";
import { SuperadminPhysicianPayoutComponent } from "./component/superadmin-physician-payout/superadmin-physician-payout.component";
import { PatientOrganisationComponent } from "./component/patient-organisation/patient-organisation.component";
import { SuperadminIllnessListComponent } from "./component/superadmin-illness-list/superadmin-illness-list.component";
import { SuperadminLabtestComponent } from "./component/superadmin-labtest/superadmin-labtest.component";
import { DocdashboardComponent } from "./component/docdashboard/docdashboard.component";
import { AddashboardComponent } from "./component/addashboard/addashboard.component";

const routes: Routes = [
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full",
  },

  {
    path: "Home",
    component: HomeComponent,
  },

  {
    path: "Home/plans",
    component: PlansComponent,
  },

  {
    path: "ack",
    component: UsrActAckComponent,
  },

  {
    path: "",
    component: componentComponent,
    canActivate: [AuthGuard, RoleGuard],
    children: [
      {
        path: "appointments",
        component: NavbarComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "appointments/Checkout/patient/:cid",
        component: PatientComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "docdashboard",
        component: DocdashboardComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "addashboard",
        component: AddashboardComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "dashboard",
        // component: DashboardComponent,
        component: DocdashboardComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "admindashboard",
        // component: AdmindashboardComponent,
        component: AddashboardComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      // Doctor Document Upload Page
      {
        path: "myfiles",
        component: MyfilesComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      //Prescription Template create
      {
        path: "prescription/template-create",
        component: PrescTempCreateComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      //Prescription Template Edit
      {
        path: "prescription/template-edit",
        component: PrescTempEditComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "superadmin/physicians",
        component: SuperadminPhysiciansComponent,
        canActivate: [AuthGuard, RoleGuard]
      },

      {
        path: "superadmin/patients",
        component: SuperadminPatientsComponent,
        canActivate: [AuthGuard, RoleGuard]
      },

      {
        path: "superadmin/coupon-generate",
        component: CouponsGenerateComponent,
        canActivate: [AuthGuard, RoleGuard]
      },

      {
        path: "superadmin/coupon-search",
        component: CouponsSearchComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "superadmin/physician-payout",
        component: SuperadminPhysicianPayoutComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "superadmin/coupon-edit/:id",
        component: CouponsEditComponent,
        //canActivate: [AuthGuard, RoleGuard]
      },

      {
        path: "superadmin/pat-detail/:id",
        component: SuperadminPatDetailComponent,
        //canActivate: [AuthGuard, RoleGuard]
      },

      {
        path: "superadmin/specialities",
        component: SpecialitiesComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "superadmin/appointments",
        component: SuperadminAppointmentComponent,
        canActivate: [AuthGuard, RoleGuard]
      },

      {
        path: "superadmin/default-payout",
        component: DefaultPayoutComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      //medicine create
      {
        path: "superadmin/medicine-create",
        component: SuperadminMedicineCreateComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      //medicine Search
      {
        path: "superadmin/medicine-search",
        component: SuperadminMedicineSearchComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      //medicine add category
      {
        path: "superadmin/medicine-add-categoy",
        component: SuperadminAddcategoryComponent,
        //canActivate: [AuthGuard, RoleGuard]
      },
      //medicine add sub category
      {
        path: "superadmin/medicine-add-subcategory",
        component: SuperadminAddsubcategoryComponent,
        //canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "superadmin/illness-list",
        component: SuperadminIllnessListComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "superadmin/labtest",
        component: SuperadminLabtestComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "phydash",
        component: PhydashComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "appointments/schedule",
        component: AppointmentsSidebarComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "appointments/past",
        component: AppointmentsPastComponent
      },
      {
        path: "patient-list",
        component: PatientListComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      // Payout page routing
      {
        path: "servicelist",
        component: PhysicianPayloadComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "superadmin/phy-detail/:id",
        component: SuperadminPhyDetailComponent,
        //canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "appointments/Checkin",
        component: CheckinComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "appointments/Checkout",
        component: CheckoutComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "profile/patient",
        component: PatientProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "profile/edit-patient",
        component: PatientEditProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "profile/patient-profile/:id",
        component: PatientEditProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "profile/delete-patient",
        component: PatientDeleteProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "profile/doctor",
        component: DoctorProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "profile/search/:type",
        component: SearchUserComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "profile/physicians-profile/:id",
        component: DoctorEditProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "profile/delete-doctor",
        component: DeleteDoctorProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "profile/fdesk-profile",
        component: FdeskProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "profile/user-profile/:id",
        component: EditFdeskProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "profile/delete-fdesk-profile",
        component: DeleteFdeskProfileComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "profile",
        component: ProfilesComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "expand-register",
        component: ExpandRegisterComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "message",
        component: MessagesComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "help",
        component: HelpComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "contact",
        component: ContactComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "Prescription",
        component: PrescriptionComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "appointments/Checkin/Detail/:cid",
        component: PatientDetailsComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "Personal-info",
        component: ExpandRegisterComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "prescrip",
        component: PrescriptionComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "patients",
        component: PatientComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "patients/:id",
        component: PatientDetailsComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      // Test
      {
        path: "phydash/:pid",
        component: PhydashComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "appointments/Checkin/edit/:aid",
        component: FrontDeskComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "editpresc/:aid",
        component: EditprescComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "update-lab/:aid",
        component: UpdateLabComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "organisation-edit/:id",
        component: OrganisationEditComponent,
        canActivate: [AuthGuard, RoleGuard],
      },

      {
        path: "org-srv",
        component: OrgsrvComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "doctor-calendar",
        component: DoctorCalendarComponent
      },
      {
        path: "appointments/request",
        component: AppointmentRequestComponent,
        canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "physician/consultation",
        component: DoctorConsultationComponent,
        /* canActivate: [AuthGuard, RoleGuard] */
      },
      {
        path: "appointment/consultation",
        component: ViewConsultationAppointmentComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "physician/transaction",
        component: PhysicianTransactionComponent
      },
      {
        path: "adhocappt/newpat",
        component: AdhocNewapptComponent,
        //canActivate: [AuthGuard, RoleGuard],
      },
      {
        path: "adhocappt/existing",
        component: AdhocApptComponent,
        //canActivate: [AuthGuard, RoleGuard],
      },
      //health stats update
      {
        path: "pathealthupdate",
        component: PatientrecsearchComponent,
        canActivate: [AuthGuard, RoleGuard]
      },
      {
        path: "patient/healthstats/update/:pid",
        component: PatientHelathStatsUpdateComponent,
      },
    ],
  },
  {
    path: "online-doctor-appointment/:id",
    component: OnlineDoctorAppointmentComponent
  },
  {
    path: "invoice",
    component: InvoiceComponent
  },
  {
    path: "conference/:aptid/:role",
    // component: VedioHomeComponent
    component: PatientChatComponent
  },
  {
    path: "patient/consultation/:aid",
    component: ConsultationSummaryComponent
  },
  {
    path: "patient/appointment/:aptid",
    component: ViewAppointmentPatientComponent
  },
  {
    path: "feedback",
    component: FeedbackComponent
  },
  {
    path: "search/appointment",
    component: AppointmentSearchComponent
  },
  {
    path: "physician/search",
    component: DoctorSearchComponent
  },
  {
    path: "login",
    component: LoginNewComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "forgotpassword",
    component: ForgotPassNewComponent
  },
  {
    path: "setNewPass",
    component: ResetPassNewComponent
  },
  {
    path: "register",
    component: CreateAccountComponent
  },

  {
    path: "info-basic",
    component: CreateAccountComponent,
  },

  {
    path: "patient/members",
    component: PatientMembersComponent,
    canActivate: [AuthGuard, RoleGuard]
  },

  {
    path: "patient/appointments",
    component: AppointmentsPatientComponent,
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: "patient/account",
    component: PatientAccountComponent,
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: "patient/add",
    component: PatientAddComponent,
    canActivate: [AuthGuard, RoleGuard]
  },
  {
    path: "patient/organisation",
    component: PatientOrganisationComponent,
  },
  {
    path: "**",
    component: PageNotFoundComponent,
  },
  // {
  //   path: "adhocappt/newpat",
  //   component: AdhocNewapptComponent,
  //   //canActivate: [AuthGuard, RoleGuard],
  // },
  // {
  //   path: "adhocappt/existing",
  //   component: AdhocApptComponent,
  //   //canActivate: [AuthGuard, RoleGuard],
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
